// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preHeader {
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    background-color: rgb(11, 12, 12);
    color: rgb(255, 255, 255);
    font-family: nta, Arial, sans-serif;
    font-weight: 400;
    height: 55px;
}
.preHeader__companyBar {
    display: flex;
    flex-direction: column;
    width: calc(100% - 30px);
    max-width: 960px;
    padding: calc(8px) 15px;
    box-sizing: border-box;
}

.preHeader__companyLogo img {
    max-height: 40px;
    max-width: 200px;
    width: 100%;
}

@media only screen and (min-width: 641px) {
    .preHeader {
        font-size: 16px;
        line-height: 1.25;
    }
    .preHeader__companyBar {
        padding: calc(8px) 0px;
        flex-direction: row;
        width: calc(100% - 60px);
    }
}
.preHeader__companyHeader {
    margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./../publicMirage/src/components/govReact/components.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wBAAwB;IACxB,uBAAuB;IACvB,iCAAiC;IACjC,yBAAyB;IACzB,mCAAmC;IACnC,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,wBAAwB;IAC5B;AACJ;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".preHeader {\n    display: flex;\n    -webkit-box-pack: center;\n    justify-content: center;\n    background-color: rgb(11, 12, 12);\n    color: rgb(255, 255, 255);\n    font-family: nta, Arial, sans-serif;\n    font-weight: 400;\n    height: 55px;\n}\n.preHeader__companyBar {\n    display: flex;\n    flex-direction: column;\n    width: calc(100% - 30px);\n    max-width: 960px;\n    padding: calc(8px) 15px;\n    box-sizing: border-box;\n}\n\n.preHeader__companyLogo img {\n    max-height: 40px;\n    max-width: 200px;\n    width: 100%;\n}\n\n@media only screen and (min-width: 641px) {\n    .preHeader {\n        font-size: 16px;\n        line-height: 1.25;\n    }\n    .preHeader__companyBar {\n        padding: calc(8px) 0px;\n        flex-direction: row;\n        width: calc(100% - 60px);\n    }\n}\n.preHeader__companyHeader {\n    margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
